export default __webpack_public_path__ + "static/media/dreamscape_class_missions_logo.84c45b00.png";